import type { TraceSidecar } from "../../../data/schemas";
import type { TraceScene, TraceScenePath, TraceScenePoint } from "./types";

export function traceColorForType(type: string): TraceScenePoint["color"] {
  const normalized = type.trim().toLowerCase();
  if (normalized.includes("enemy")) return "red";
  if (normalized.includes("friendly") || normalized.includes("control"))
    return "blue";
  return "black";
}

function scenePoint(
  point: TraceSidecar["features"][number],
  kind: TraceScenePoint["kind"],
): TraceScenePoint {
  return {
    color: traceColorForType(point.type),
    id: point.id,
    kind,
    label: point.label,
    type: point.type,
    x: point.x * 1000,
    y: point.y * 1000,
  };
}

function scenePath(phase: TraceSidecar["phases"][number]): TraceScenePath {
  return {
    bindItemId: phase.bindItemId,
    detail: phase.detail,
    id: phase.id,
    label: phase.label,
    markerIds: phase.markers,
    points: phase.path
      .map(([x, y]) => `${String(x * 1000)},${String(y * 1000)}`)
      .join(" "),
  };
}

export function buildTraceScene(sidecar: TraceSidecar): TraceScene {
  return {
    points: [
      ...sidecar.features.map((point) => scenePoint(point, "feature")),
      ...sidecar.markers.map((point) => scenePoint(point, "marker")),
    ],
    paths: sidecar.phases.map(scenePath),
  };
}
